// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3CRfS","alertIcon":"ConfirmModal_alertIcon__3ZB5R"};